import {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { RemoveTypenameFromVariablesLink } from '@apollo/client/link/remove-typename';
import { ApolloProvider as BaseApolloProvider } from '@apollo/client/react';
import { UploadHttpLink } from '@hyperse/apollo-upload-client';

import { configService } from '@bluecodecom/onboarding-webview/features/config';

const ApolloProvider: FC<PropsWithChildren> = ({ children }) => {
  const [client, setClient] = useState<ApolloClient | null>(null);

  const initializedRef = useRef(false);

  const initialize = useCallback(async () => {
    initializedRef.current = true;

    const cache = new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            onboarding: {
              keyArgs: false,
            },
          },
        },
      },
    });

    const errorLink = new ErrorLink(({ error }) => {
      console.log({ error });
    });

    const httpLink = new UploadHttpLink({
      // uri: () => 'http://localhost:6789/client/graphql',
      credentials: 'include',
      uri: () =>
        `https://onboarding-api.${configService.domain}/client/graphql`,
    });
    const removeTypenameLink = new RemoveTypenameFromVariablesLink();

    setClient(
      new ApolloClient({
        link: ApolloLink.from([removeTypenameLink, errorLink, httpLink]),
        cache,
        devtools: { enabled: true },
      }),
    );
  }, []);

  useEffect(() => {
    if (initializedRef.current) {
      return;
    }

    initialize();
  }, [initialize]);

  if (!client) {
    return null;
  }

  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
};

export default ApolloProvider;
